import { useTranslation } from 'react-i18next'
import { WarningIcon20 } from '../../../icons'

export interface EmptyFieldsWarningProps {
  'data-testid': string
}

export default function EmptyFieldsWarningAppendix({
  'data-testid': testId
}: Readonly<EmptyFieldsWarningProps>) {
  const { t } = useTranslation('ui-befehle')

  return (
    <div
      className="flex gap-0.5 px-0.5 py-0.25 items-center bg-red-100 border rounded-b-sm border-red-100 dark:bg-red-600 dark:border-red-600 dark:text-cool-gray-200 text-sm"
      data-testid={testId}
    >
      <WarningIcon20
        data-testid={`${testId}-icon`}
        className="fill-current inline-block dark:text-cool-gray-200"
      />
      <span className="text-xs" data-testid={`${testId}-warning-text`}>
        {t('representation.missing_field_error')}
      </span>
    </div>
  )
}
